import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

/**
 * 吹き出し用メッセージ情報取得
 */
import { ApiTaMg010 } from '~/endpoints/ApiTaMg010'
import { CoursePlanData } from '~/store/apis/ContractCoursePlan'

// State types
export interface StateChrMessage {
  id: string
  message: string
  statusCode: number
  error: {
    messageId: string
    message: string
  } | null
}
export const getEmptyStateChrMessage = (): StateChrMessage => ({
  id: '',
  message: '',
  statusCode: 0,
  error: null,
})

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/ChrMessage',
})
export default class ChrMessage extends VuexModule {
  // States
  private state_: StateChrMessage = getEmptyStateChrMessage()

  // Getters

  get result(): StateChrMessage {
    return this.state_
  }

  // Mutations

  @Mutation
  updateChrMessage(value: StateChrMessage) {
    this.state_ = value
  }

  static readonly MUTATION_NAME_UPDATE_STATE = 'updateChrMessage'

  // Actions

  @Action
  clear() {
    this.context.commit(ChrMessage.MUTATION_NAME_UPDATE_STATE, getEmptyStateChrMessage())
  }

  @Action
  async getChrMessage(coursePlandata: CoursePlanData) {
    logger.trace('in: getChrMessage')
    const api = new ApiTaMg010.Api()

    // API
    const result = await api.get<StateChrMessage>(
      {
        query: coursePlandata,
      },
      // Success
      (data, status) => {
        return {
          id: data.id,
          message: data.message,
          statusCode: status,
          error: null,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return {
          id: getEmptyStateChrMessage().id,
          message: getEmptyStateChrMessage().message,
          statusCode: status,
          error: {
            messageId: data.error.messageId,
            message: data.error.message,
          },
        }
      }
    )

    const commitdata: StateChrMessage = getEmptyStateChrMessage()
    if (result) {
      commitdata.statusCode = result.statusCode
      commitdata.error = result.error
      if (commitdata.error === null) {
        commitdata.id = result.id
        commitdata.message = result.message
      }
    }
    this.context.commit(ChrMessage.MUTATION_NAME_UPDATE_STATE, commitdata)
  }
}
